import { AwsConfig } from '../Constants';
import BaseService, { RequestInterface } from '../Base';
import { graphqlOperation } from 'aws-amplify';

class GroupService extends BaseService {
  constructor() {
    super(AwsConfig.API_CONFIG, 'graphql');
  }

  async listUserGroups() {
    const graphQlBody = {
      "query": `{ listUserGroups { id name groupsPermission created_by alias } }`
    }

    const params: RequestInterface = {
      body: graphQlBody
    }

    const res = await super.post('', params)
    return res
  }

  async getUserGroup(id: number) {
    const graphQlBody = {
      "query": `{ getUserGroup (id: ${id}) { id name permissions { group_permission_id rule target_group_id } } }`
    }

    const params: RequestInterface = {
      body: graphQlBody
    }

    const res = await super.post('', params)
    return res
  }

  async deleteUserGroup (id: number) {
    const graphQlBody = `
      mutation deleteUserGroup($data: Int!) {
        deleteUserGroup(id: $data)
      }
    `
    const query = graphqlOperation(graphQlBody, { data: id })
    const params: RequestInterface = { body: query }
    const res = await super.postGraphQl('', params)

    return res;
  }
}

export default GroupService
